var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.title) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("common.close"),
                  expression: "$ct('common.close')",
                },
              ],
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _vm.step == 1
        ? _c("app-frequency-settings-edit-select-frequency-type", {
            attrs: { state: _vm.state },
          })
        : _vm.step == 2
        ? _c("app-freqeuncy-setting-edit", { attrs: { state: _vm.state } })
        : _vm.step == 3
        ? _c("app-preview-dates", { attrs: { state: _vm.state } })
        : _vm._e(),
      _c("app-mail-settings", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.step == 4,
            expression: "step == 4",
          },
        ],
        attrs: { state: _vm.state },
      }),
      _vm.step == 5
        ? _c(
            "w-scroll-view",
            { staticClass: "finish", attrs: { tag: "w-card-content" } },
            [_c("app-finish", { attrs: { state: _vm.state } })],
            1
          )
        : _vm._e(),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: _vm.backIcon },
              on: {
                click: function ($event) {
                  return _vm.backClicked()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.backButtonText) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: _vm.nextIcon },
              on: {
                click: function ($event) {
                  return _vm.nextClicked()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.nextButtonText) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }